import { open, openAsync } from "@op-engineering/op-sqlite";
import { openKeyValue } from "./keyValue.native";
var Database = Object.freeze({
  open,
  openAsync,
  openKeyValue
});
export {
  Database
};
//# sourceMappingURL=index.native.js.map
